import { gql } from '@apollo/client'

import { SHOP_FRAGMENT } from '../fragments'

export const GET_CURRENT_SHOP = gql`
  query CurrentShop {
    currentShop {
      ...Shop
    }
  }
  ${SHOP_FRAGMENT}
`
